import { useEffect } from 'react';

const useAutoSave = ({ first, second, saveHandler, isLoading, timeoutValue = 800, dependency = [], isDisabled }) => {
  useEffect(() => {
    let timeout;
    if (!isDisabled && !isLoading && first !== second) {
      timeout = setTimeout(saveHandler, timeoutValue);
    }

    return () => clearTimeout(timeout);
  }, [...dependency, isLoading, isDisabled]);

  return null;
};

export default useAutoSave;
